import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IndexComponent } from './pages/index/index.component';
import { UsComponent } from './pages/us/us.component';
import { ContactComponent } from './pages/contact/contact.component';
import { CalibrationsComponent } from './pages/calibrations/calibrations.component';
import { ServicesComponent } from './pages/services/services.component';
import { SellEquipmentComponent } from './pages/sell-equipment/sell-equipment.component';
import { RepairEquipmentComponent } from './pages/repair-equipment/repair-equipment.component';
import { TrainingComponent } from './pages/training/training.component';
import { AccreditationsComponent } from './pages/accreditations/accreditations.component';
import { ThanksComponent } from './pages/thanks/thanks.component';
import { IndexLayoutComponent } from './layouts/index-layout/index-layout.component';
import { CalibrationsLayoutComponent } from './layouts/calibrations-layout/calibrations-layout.component';
import { ContactLayoutComponent } from './layouts/contact-layout/contact-layout.component';
import { SecurityLayoutComponent } from './layouts/security-layout/security-layout.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'calibraciones',
    pathMatch: 'full'
  },
  {
    path: 'inicio',
    component: IndexLayoutComponent,
    children: [{ path: '', component: IndexComponent }]
  },
  {
    path: 'seguridad',
    component: SecurityLayoutComponent,
    loadChildren: () => import('./modules/security/security.module').then(mod => mod.SecurityModule)
  },
  {
    path: '',
    component: CalibrationsLayoutComponent,
    children: [
      { path: 'calibraciones', component: CalibrationsComponent },
      { path: 'nosotros', component: UsComponent },
      { path: 'servicios', component: ServicesComponent },
      { path: 'equipo/venta', component: SellEquipmentComponent },
      { path: 'equipo/reparacion', component: RepairEquipmentComponent },
      { path: 'capacitacion', component: TrainingComponent },
      { path: 'acreditaciones', component: AccreditationsComponent },
      { path: 'gracias', component: ThanksComponent },
      { path: 'error', component: ThanksComponent }
    ]
  },
  {
    path: '',
    component: ContactLayoutComponent,
    children: [{ path: 'contacto', component: ContactComponent }]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
